import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { AspectRatio as n } from "./aspectRatio.js";
import { MediaDisclosureButton as x } from "./mediaDisclosureButton.js";
import { u as a } from "./index-6a632112.mjs";
import "./themes-5f0b3c3d.mjs";
import "react";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
const l = a.div`
  position: relative;
  overflow: hidden;
`, u = a(n)`
  border-radius: ${(t) => {
  switch (t.radii) {
    case "none":
      return "0px";
    case "4px":
      return "4px";
    case "8px":
      return "8px";
    case "12px":
      return "12px";
    default:
      return "0px";
  }
}};
  overflow: hidden;
`, w = ({
  src: t,
  style: p,
  radii: e,
  disclosureLinks: o,
  ...i
}) => (i.ratio || e || o) && /* @__PURE__ */ m(l, { children: [
  /* @__PURE__ */ r(u, { style: p, radii: e, ...i, children: /* @__PURE__ */ r("img", { src: t.url, alt: t.alt }) }),
  o && /* @__PURE__ */ r(
    x,
    {
      ...o,
      alignment: "bottom-right",
      containerPosition: { bottom: "8px", right: "24px" }
    }
  )
] }) || /* @__PURE__ */ r("img", { src: t.url, alt: t.alt });
export {
  w as Image
};
